<template>
<!-- This row is the title -->
<div class="d-flex h-60 flex-column">
  <div class="loading abcenter" v-if="showOverlay">
    <div class="spinner-grow text-primary abcenter" role="status"></div>
  </div>
  <b-modal id="planwarning" title="NEURON warning" hide-header-close ok-only>
    {{ planwarningtext }}
  </b-modal>
  <b-modal id="notif" title="NEURON message" hide-header-close ok-only>
    Original plan has been copied. Please paste it at <a href="http://tatiyants.com/pev/#/plans/new" target="_blank">here</a>.
  </b-modal>
  <div class="row text-center m-1">
    <div class="col-sm-6">
      <span class="thick">SQL query</span>
    </div>
    <div class="col-sm-6">
      <span class="thick">Natural language description of QEP</span>
    </div>
  </div>
  <!-- This row is the text boxes -->
  <div class="row flex-fill">
    <div class="col-sm-6">
      <textarea v-model="sqltext" class="form-control h-100" placeholder="Enter your query here..."></textarea>
    </div>
    <div class="col-sm-6">
      <textarea v-model="plantext" class="form-control form-control-plaintext h-100" readonly></textarea>
    </div>
  </div>
  <div class="row text-center m-1">
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary" v-on:click="sendSQL()">
        <span v-if="executing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
	{{ submitText }}
      </button>
    </div>
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary mr-1" v-on:click="playPause()" :disabled="!this.planAvailable">{{ playButton }}</button>
      <button type="button" class="btn btn-primary mr-1" v-on:click="copy()" :disabled="!this.planAvailable">Copy plan</button>
      <!-- <a target="_blank" href="/treeviz" class="btn btn-primary" :class="!this.planAvailable && 'disabled'">Visualize plan</a> -->
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { getPlan } from '@/api.js'

export default {
  data: function() {
    return {
      sqltext: '',
      plantext: '',
      originalplan: '',
      playing: false,
      pausing: false,
      playButton: "Play",
      utter: null,
      planwarningtext: '',
      submitText: 'Submit',
      executing: false,
      showOverlay: false
    }
  },
  computed: {
    ...mapState([
      'planAvailable',
      'db',
      'email'
    ])
  },
  methods: {
    async sendSQL() {
      if (this.sqltext === "") {
        this.planwarningtext = "You cannot submit empty SQL query!"
        this.$bvModal.show("planwarning")
        return;
      }
      this.$store.commit("setPlanAvailability", false)
      this.plantext = ""
      this.submitText = "Executing..."
      this.executing = true;

      // send HTTP request
      this.showOverlay = true;
      try {
        let response = await getPlan(this.sqltext, this.db, this.email)
        this.showOverlay = false;
        if (response.data["code"] === "f") {
          this.planwarningtext = response.data["text"]
          this.$bvModal.show("planwarning")
        } else {
          this.plantext = response.data["text"]
          this.originalplan = response.data["original"]
          this.$store.commit("setPlanAvailability", true)
        }
      }
      catch (err) {
        this.showOverlay = false
      }

      // restore state after submission
      this.submitText = "Submit"
      this.executing = false
    },
    playPause() {
      if (!this.planAvailable) {
        this.planwarningtext = "Please get the query execution plan first before playing!";
        this.$bvModal.show("planwarning");
        return;
      }
      var synth = window.speechSynthesis;
      if (!synth.speaking) {
        this.playing = false;
        this.pausing = false;
      }
      if (!synth.speaking) {
        // the text hasn't been played yet
        synth.cancel();
        this.utter = new SpeechSynthesisUtterance();
        this.utter.text = this.plantext;
        this.utter.onend = this.onPlayEnd;
        synth.speak(this.utter);
        this.playButton = "Pause";
        //this.playing = true;
      } else if (synth.speaking && !synth.paused) {
        // pause playing
        synth.pause();
        this.playButton = "Play";
        //this.pausing = true;
      } else if (synth.speaking && synth.paused) {
        // resume playing
        synth.resume();
        this.playButton = "Pause";
        //this.pausing = false;
      }
      //console.log(this.playing);
      //console.log(this.pausing);
    },
    onPlayEnd() {
      this.playButton = "Play";
      this.playing = false;
    },
    async copy() {
      if (!this.planAvailable) {
        this.planwarningtext = "You haven't obtained a plan yet.";
        this.$bvModal.show("planwarning");
        return;
      }
      try {
        await this.$copyText(this.originalplan)
        this.$bvModal.show("notif");
      }
      catch (err) {
        this.planwarningtext = "The original plan cannot be copied.";
        this.$bvModal.show("planwarning");
      }
    }
  }
}
</script>
